// extracted by mini-css-extract-plugin
export default {"button":"StylesGlobal_button__XnSpq"};